import React from "react";
import {
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Typography,
} from "@mui/material";
const ToggleButtonAdapter = ({
  name,
  input,
  meta,
  _loading,
  _options,
  label,
  ...rest
}) => {
  return (
    <FormControl
      error={meta.error && meta.touched}
      {...rest}
      aria-label={label}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid>
          <ToggleButtonGroup
            style={{ padding: "1%" }}
            color="primary"
            exclusive
            name={name}
            checked={input.checked}
            onChange={input.onChange}
            value={input.value}
            size="xs"
          >
            {[
              <ToggleButton key="yes" value="yes">
                Yes
              </ToggleButton>,
              <ToggleButton key="no" value="no">
                No
              </ToggleButton>,
            ]}
          </ToggleButtonGroup>
        </Grid>
        <Grid>
          <Typography>{label}</Typography>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default ToggleButtonAdapter;
